<!-- 报废出库 -->
<template>
  <article class="out_bound">
    <group title="报废情况">
      <datetime
        v-model="formData.transaction_date"
        title="成交日期"
        placeholder="请选择日期"
        confirm-text="确定"
        cancel-text="取消"
        inline-desc="*"
        @on-change="change"
        class="deal_date">
      </datetime>
      <x-input
        v-for="(item, index) in inputLists" :key="index"
        v-model="formData[item.name]"
        :placeholder="item.placeholder"
        :required="item.required"
        :is-type="item.validate"
        :keyboard="item.type"
        :name="item.name"
        :max="11"
        :class="{'price-verify': item.verify}">
        <div slot="label"><span class="red_dots" v-if="item.required">*</span>{{item.title}}</div>
        <span slot="right">{{item.unit}}</span>
      </x-input>
      <x-input
        v-model="calculateData['car_gross_profit']"
        title="车辆毛利"
        placeholder=""
        :readonly="true">
        <span slot="right">元</span>
      </x-input>
    </group>
    <group title="备注">
      <x-textarea
        v-model="formData.remark"
        :max="255"
        :show-counter="true"
        placeholder="请输入内容（非必填）">
      </x-textarea>
    </group>
    <upload-pic
      :images.sync="formData.images"
      :show-name="imagesConfig.showName"
      :dragable="imagesConfig.dragable"
      :count="imagesConfig.length"
      @upload="ImgUpload"
      @delete="ImgDelete">
      <p class="title">{{imagesConfig.title}}</p>
    </upload-pic>
    <footer-btn title="提交" :is-ready="!allValidate" @submit="onSubmit()"></footer-btn>
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“元”，你所输入的以下金额小于100元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </article>
</template>

<script>
import { Group, XTextarea, Datetime, XInput, XAlert, UploadPic } from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import util from '../../common/util'
import cache from '../../common/cache'
import { Decimal } from 'decimal.js'
export default {
  components: {
    Group,
    XTextarea,
    Datetime,
    XInput,
    UploadPic,
    FooterBtn,
    XAlert
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      dialogContent: [], // 提示文本
      carId: '',
      inputLists: [],
      validForm: { // 需验证的必填项
        car_cost: false,
        car_income: false,
        transaction_date: false
      },
      formData: {
        car_cost: '',
        car_income: '',
        transaction_date: '',
        remark: '',
        images: []
      },
      priceKeys: ['car_cost', 'car_income'],
      imagesConfig: {
        showName: false,
        dragable: false,
        requestUrl: 'getImageByAuction',
        title: '凭证照片（如回收证明等）',
        length: 10
      }
    }
  },
  created() {
    this.inputLists = [{
      title: '车辆成本',
      name: 'car_cost',
      placeholder: '请输入',
      unit: '元',
      type: 'text',
      validate: this.val_price,
      required: true,
      verify: false // 是否做价格提示
    }, {
      title: '车辆收入',
      name: 'car_income',
      placeholder: '请输入',
      unit: '元',
      type: 'text',
      validate: this.val_price,
      required: true,
      verify: false // 是否做价格提示
    }]
    let lastFormData = cache.getSessionData('OUTBOUND_FROM_DATA')
    this.carId = this.$route.params.id
    if (lastFormData) {
      this.formData = this.getFormatData(lastFormData)
      this.validForm.transaction_date = true
    } else {
      this.$rest.auction.getVehicleCarDetail(null, this.carId).then((res) => {
        if (res.code === 0) {
          let price = res.data.contract_price
          if (price) {
            this.formData.car_cost = new Decimal(price).div(100).toNumber()
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  computed: {
    calculateData() {
      let carGrossProfit = ''
      if (this.validForm.car_income && this.validForm.car_cost) {
        carGrossProfit = new Decimal(+this.formData.car_income).minus(+this.formData.car_cost).toNumber()
      }
      return { car_gross_profit: carGrossProfit }
    },
    allValidate () {
      let isValid = true
      let keys = Object.keys(this.validForm)
      let values = Object.values(this.validForm)
      // 判断必填项是否有值
      for (let i = 0, len = keys.length; i < len; i++) {
        if (!this.formData[keys[i]]) {
          isValid = false
          break
        }
      }
      // 校验必填项
      for (let i = 0, len = values.length; i < len; i++) {
        if (!values[i]) {
          isValid = false
          break
        }
      }
      return isValid
    }
  },
  methods: {
    getFormatData(data) {
      this.priceKeys.forEach(v => {
        data[v] = (data[v] / 100).toFixed(2)
      })
      data.images = data.images.map(v => {
        return v.src
      })
      return data
    },
    postData() {
      let formatData = {}
      this.priceKeys.forEach(v => {
        let value = +this.formData[v]
        formatData[v] = new Decimal(value).mul(100).toNumber()
      })
      if (this.formData.images.length > 0) {
        formatData.images = this.formData.images.map(v => {
          return { code: 'other', src: v.src }
        })
      }
      let params = { ...this.formData, ...formatData }
      this.$rest.outBound.postScrap(params, this.carId).then(res => {
        if (res.code === 0) {
          this.$router.push(`/outbound/succ/${res.data.id}`)
        } else {
          this.showToast(res.message)
        }
      })
    },
    val_price(val, name) {
      let valid = util.regexpMap.regexp_price.test(val)
      let result = this.validate(valid, '请输入有效的价格，小数点最多保留两位')
      this.validForm[name] = valid // 即时存储表单校验结果
      if (!result.valid) {
        this.showToast(result.msg)
      }
      // 组件input的isType自定义函数，需要返回包含布尔值valid和msg这两个属性的对象
      return result
    },
    validate(valid, msg) {
      return { valid: valid, msg: msg }
    },
    change(val) {
      this.validForm.transaction_date = true
    },
    onSubmit() {
      // 判断必填项是否已全部填完，若填完提交按钮高亮并能提交
      if (this.allValidate) {
        if (this.isVerify) {
          const ispass = this.priceVerify()
          if (!ispass) {
            return false
          }
        }
        this.postData()
      } else {
        this.showToast('请将必填信息填写完整后再提交')
      }
    },
    // 金额防错提示
    priceVerify() {
      if (this.formData.car_cost < 100) {
        this.toggleVerify('car_cost')
        this.dialogContent.push(`车辆成本：${this.formData.car_cost}元`)
      }
      if (this.formData.car_income < 100) {
        this.toggleVerify('car_income')
        this.dialogContent.push(`车辆收入：${this.formData.car_income}元`)
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    },
    toggleVerify(name) {
      for (let i = 0, len = this.inputLists.length; i < len; i++) {
        const item = this.inputLists[i]
        if (item.name === name) {
          this.inputLists[i].verify = true
          break
        }
      }
    },
    ImgUpload(i) {
      let iamges = this.formData.images
      this.$wechat.imgUpLoad(this, i, iamges, this.imagesConfig.requestUrl)
    },
    ImgDelete(i) {
      let iamges = this.formData.images
      this.$wechat.imgDelete(i, iamges)
    }
  }
}
</script>

<style lang="less">
@import '../../stylesheets/base/fn';
@import '../../stylesheets/base/mixin/common.less';
.out_bound {
  .weui_cell_hd{width: 210/@w2;}
  .deal_date {
    .weui_cell_bd{
      width: 210/@w2;
      overflow: hidden;
      p{display: inline-block;}
    }
    .vux-label-desc {
      color: red;
      float: left;
    }
  }
  .red_dots{color: red;}
}

</style>
